module.exports = __webpack_public_path__ + "static/img/deportes_05.dd1a91eb.jpeg";